import { animate, spring, inView, stagger } from 'motion';

//Motion One Animations

inView('.motion-banner', (el) => {
    animate(el.target, { y: [60, 0], opacity: [0, 1] }, { duration: 0.7, delay: 0.2 });
});

animate('#hero_text', { x: ['-110%', 0], opacity: [0, 1] }, { duration: 1 });

animate(
    '.news-blog-card',
    { y: [50, 0], opacity: [0, 1] },
    { delay: stagger(0.2, { start: 0.7 }), easing: spring({ damping: 14 }) }
);

animate(
    '.product-card',
    { y: [50, 0], opacity: [0, 1] },
    { delay: stagger(0.1, { start: 0.7 }), easing: spring({ damping: 17 }) }
);

inView('.animate-bard-column', (el) => {
    animate(el.target, { opacity: [0, 1] }, { duration: 1.6, delay: 0.3 });
});

//Video Player

const videoPlaceholders = document.querySelectorAll('.product-video-placeholder');
const videoPlayers = document.querySelectorAll('.product-video-player');

videoPlaceholders.forEach((placeholder) => {
    placeholder.addEventListener('click', () => {
        placeholder.style.display = 'none';

        videoPlayers.forEach((player) => {
            if (player.getAttribute('data-video-id') == placeholder.getAttribute('data-video-id')) {
                player.style.opacity = 1;
                player.setAttribute('src', player.getAttribute('src') + '?autoplay=1');
            }
        });
    });
});

//Carousel

document.addEventListener('DOMContentLoaded', () => {
    const carouselItems = document.querySelectorAll('.carousel-item');
    const carouselMarkers = document.querySelectorAll('.carousel-marker');

    let slides = carouselItems.length;
    let carouselTimer;
    let activeSlide = 0;

    if (slides) {
        const updateTimer = () => {
            activeSlide++;

            updateCarouselonInterval(carouselItems, carouselMarkers);
        };

        carouselTimer = setInterval(updateTimer, 5000);

        const updateCarouselonInterval = (items, markers) => {
            if (activeSlide < slides) {
                items.forEach((item, itemIndex) => {
                    if (itemIndex == activeSlide) {
                        item.style.display = 'block';
                        item.classList.add('active');
                        animate(item, { x: ['150vw', 0] }, { delay: 0.1, duration: 0.9 });
                    } else if (item.classList.contains('active')) {
                        animate(item, { x: '-150vw' }, { duration: 0.4 }).finished.then(() => {
                            item.style.display = 'none';
                            item.classList.remove('active');
                        });
                    }
                });

                markers.forEach((marker, markerIndex) => {
                    if (markerIndex == activeSlide) {
                        marker.style.backgroundColor = '#A1C039';
                    } else {
                        marker.style.backgroundColor = '#C9CFD8';
                    }
                });
            }

            if (activeSlide == slides) {
                items.forEach((item, itemIndex) => {
                    if (itemIndex == 0) {
                        item.style.display = 'block';
                        item.classList.add('active');
                        animate(item, { x: ['150%', 0] }, { delay: 0.1, duration: 0.9 });
                        activeSlide = 0;
                    } else if (item.classList.contains('active')) {
                        animate(item, { x: '-150%' }, { duration: 0.4 }).finished.then(() => {
                            item.style.display = 'none';
                            item.classList.remove('active');
                        });
                    }
                });

                markers.forEach((marker, markerIndex) => {
                    if (markerIndex == 0) {
                        marker.style.backgroundColor = '#A1C039';
                    } else {
                        marker.style.backgroundColor = '#C9CFD8';
                    }
                });
            }
        };

        carouselMarkers.forEach((marker, markerIndex) => {
            marker.addEventListener('click', (event) => {
                carouselItems.forEach((item, itemIndex) => {
                    if (itemIndex == markerIndex) {
                        item.style.display = 'block';
                        item.classList.add('active');
                        if (itemIndex > activeSlide) {
                            animate(item, { x: ['150%', 0] }, { delay: 0.1, duration: 0.7 });
                        } else {
                            animate(item, { x: ['-150%', 0] }, { delay: 0.1, duration: 0.7 });
                        }
                        activeSlide = itemIndex;
                        clearInterval(carouselTimer);
                        carouselTimer = setInterval(updateTimer, 5000);
                    } else if (item.classList.contains('active')) {
                        if (itemIndex > activeSlide) {
                            animate(item, { x: '150%' }).finished.then(() => {
                                item.style.display = 'none';
                                item.classList.remove('active');
                            });
                        } else {
                            animate(item, { x: '-150%' }).finished.then(() => {
                                item.style.display = 'none';
                                item.classList.remove('active');
                            });
                        }
                    }
                });

                carouselMarkers.forEach((marker) => {
                    if (marker == event.target) {
                        marker.style.backgroundColor = '#A1C039';
                    } else {
                        marker.style.backgroundColor = '#C9CFD8';
                    }
                });
            });
        });
    }
});

// Map Viewer

document.addEventListener('DOMContentLoaded', () => {
    const activeCountries = document.querySelectorAll('.list-country');
    const displayContainer = document.getElementById('hovered-country-display');
    const displayTitle = document.getElementById('hovered-country-title');
    const displayDescription = document.getElementById('hovered-country-description');
    const worldMap = document.getElementById('world-map');

    if (worldMap) {
        const updateContainer = (e) => {
            displayContainer.style.left = e.pageX + 10 + 'px';
            displayContainer.style.top = e.pageY + 10 + 'px';
        };

        activeCountries.forEach((activeCountry) => {
            const mapCountry = document.querySelector(`.${activeCountry.dataset.countryCode}`);

            if (mapCountry) {
                const name = mapCountry.getAttribute('name');
                const description = document.getElementById(
                    `${activeCountry.dataset.countryCode}-description`
                ).innerHTML;

                const countryCode = activeCountry.dataset.countryCode;

                document.querySelectorAll(`.${countryCode}`).forEach((item) => {
                    item.classList.add('active-country');

                    item.addEventListener('mouseenter', () => {
                        displayContainer.style.display = 'block';
                        displayTitle.innerText = name;
                        displayDescription.innerHTML = description;

                        item.style.fill = '#A1C039';
                        document.querySelectorAll(`.${countryCode}`).forEach((country) => {
                            country.style.fill = '#A1C039';
                        });
                        worldMap.addEventListener('mousemove', updateContainer);
                        animate(displayContainer, { y: [19, 0] }, { duration: 0.7 });
                    });

                    item.addEventListener('mouseleave', (e) => {
                        displayContainer.style.display = 'none';
                        item.style.fill = '#3E506B';
                        document.querySelectorAll(`.${countryCode}`).forEach((country) => {
                            country.style.fill = '#3E506B';
                        });
                        worldMap.removeEventListener('mousemove', updateContainer);
                    });
                });
            }
        });
    }
});
